"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    handleChooseHotelRoomButtonClick: ()=>handleChooseHotelRoomButtonClick,
    ChooseHotelRoomButton: ()=>ChooseHotelRoomButton
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
require("react");
const analytics_js_namespaceObject = require("../analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const handleChooseHotelRoomButtonClick = ({ hotelId, args, detailURL, clickedOnMap = 'N' })=>(event)=>{
        event.stopPropagation?.();
        event.preventDefault?.();
        analytics_js_default().log({
            label: 'HotelSearchResult',
            hotelId: hotelId,
            message: 'HOTEL_DETAIL_LINK_CLICKED',
            clickedOnMap,
            ...args
        });
        window.open(detailURL, '_blank');
    };
const ChooseHotelRoomButton = (props)=>{
    const { buttonProps, buttonCopy, detailURL, hotelId, args } = props;
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
        ...buttonProps,
        onClick: handleChooseHotelRoomButtonClick({
            hotelId,
            args,
            detailURL
        }),
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
            bold: true,
            fontSize: 0,
            children: buttonCopy
        })
    });
};
ChooseHotelRoomButton.defaultProps = {
    buttonCopy: 'Choose Room',
    buttonProps: {},
    detailURL: '',
    hotelId: '',
    args: {}
};
exports.ChooseHotelRoomButton = __webpack_exports__.ChooseHotelRoomButton;
exports.handleChooseHotelRoomButtonClick = __webpack_exports__.handleChooseHotelRoomButtonClick;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "ChooseHotelRoomButton",
    "handleChooseHotelRoomButtonClick"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
